export default __webpack_public_path__ + "static/media/undraw_Images_re_0kll.2ae668ce.svg";